import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { companyRecordOperation } from '@norum/contracts';
import { appPath, post, type AppPath } from './client';
import { useTodayPost } from './TodayContext';

export interface RecordScope { companyId:string;sourceKind:string;sourceId:string;scopeDepartment:string }
const Context=createContext<RecordScope|null>(null);
/** The validated company-origin panel context; this grants no server access. */
export function useRecordScope(): RecordScope | null { return useContext(Context); }
export function RecordScopeProvider({scope,children}:{scope:RecordScope;children:ReactNode}) {
 return <Context.Provider value={scope}>{children}</Context.Provider>;
}
/** A closure for this panel only. Another tab's reads never borrow its scope. */
export function useRecordPost():typeof post {
 const todayPost=useTodayPost();
 const scope=useContext(Context);const qc=useQueryClient();
 return useMemo(()=>async<T,>(path:AppPath,payload:Record<string,unknown>={}):Promise<T>=>{
  if(!scope || !companyRecordOperation(scope.sourceKind,path)) return todayPost<T>(path,payload);
  const result=await post<T>(appPath('/v1/companies/record/call'),{...scope,path,payload});
  if(!/(?:\/get|\/read|\/list|\/room|\/standing|\/assignees|\/prospect|\/campaign)$/.test(path)) {
   void qc.invalidateQueries({queryKey:['company-workspace']});
  }
  return result;
 },[scope,qc,todayPost]);
}
